import { render, staticRenderFns } from "./shortVideoList.vue?vue&type=template&id=48dd6ed0&scoped=true&"
import script from "./shortVideoList.vue?vue&type=script&lang=js&"
export * from "./shortVideoList.vue?vue&type=script&lang=js&"
import style0 from "./shortVideoList.vue?vue&type=style&index=0&id=48dd6ed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd6ed0",
  null
  
)

export default component.exports